import { useState } from "react";
import { Button, Form, Input, message, Modal, Select } from "antd";

import { addConJobType } from "sr/utils/api/company/contractor/addConJobType";
import { updateConJobType } from "sr/utils/api/company/contractor/updateConJobType";

const AssignJobTypenModal = (props: any) => {
  const [isLoading, setIsLoading] = useState(false);
  const [errors, setErrors] = useState<any>("");

  const checkDuplicate = (newData: any) => {
    try {
      const list = props?.currentData;
      if (!Array.isArray(list)) return true;
      let check = list.filter(
        (item: any) =>
          item.job_type === newData.job_type && item.id !== newData.id
      );
      return check?.length > 0 ? false : true;
    } catch (err) {
      console.error("Error :", err);
      return false;
    }
  };

  const submit = async (values: any) => {
    try {
      setErrors("");
      var respose: any = {};
      let obj = {
        id: props?.data?.id,
        company_id: props?.company_id,
        contractor_id: props?.contractor_id,
        job_type: values?.job_type,
        rate: Number(values?.rate),
      };
      if (checkDuplicate(obj)) {
        setIsLoading(true);
        if (props?.data?.id) {
          respose = await updateConJobType(obj);
        } else {
          respose = await addConJobType(obj);
        }
        if (respose?.success) {
          props?.close();
          props?.onRefresh();
        } else {
          message.error(respose?.message);
        }
      } else {
        setErrors("Job type already exists");
      }
      setIsLoading(false);
    } catch (err) {
      message.error("Something went wrong");
      console.error("Error :", err);
      setIsLoading(false);
    }
  };

  return (
    <Modal
      title={props?.data?.id ? "Update Job Type" : "Assign Job Types"}
      open={props?.visible}
      onCancel={() => props?.close()}
      footer={false}
      width={400}
      centered
    >
      <br />
      <Form
        onFinish={submit}
        layout="vertical"
        initialValues={{
          job_type: props?.data?.job_type,
          rate: props?.data?.rate,
        }}
      >
        <Form.Item
          label="Job Type"
          name={"job_type"}
          rules={[{ required: true, message: "Last name is required" }]}
        >
          <Select size="large" placeholder="Select Job Type">
            {props?.category?.map((item: any) => (
              <Select.Option key={item?.value} value={item?.value}>
                {item?.label}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>
        <Form.Item
          label="Hourly Rate"
          name={"rate"}
          rules={[{ required: true, message: "Last name is required" }]}
        >
          <Input
            prefix="$"
            type={"number"}
            size="large"
            placeholder="Enter Hourly Rate"
          />
        </Form.Item>
        {errors?<div className="text-red-500 text-[14px]">{errors}</div>:null}
        <div className="flex gap-4 mt-8">
          <Button size="large" block danger onClick={() => props?.close()}>
            Close
          </Button>
          <Button
            size="large"
            type="primary"
            htmlType="submit"
            block
            loading={isLoading}
          >
            Save Changes
          </Button>
        </div>
      </Form>
    </Modal>
  );
};

export default AssignJobTypenModal;
